import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import useThemeStyles from '../hooks/useThemeStyles';

const WordCountPill = ({ wordCount, sx = {} }) => {
  const { isDark } = useThemeStyles();

  if (typeof wordCount !== 'number') {
    return null;
  }

  const formattedCount = wordCount.toLocaleString();
  const suffix = wordCount === 1 ? 'word' : 'words';

  return (
    <Chip
      label={`${formattedCount} ${suffix}`}
      size="small"
      sx={{
        height: 20,
        fontSize: '0.7rem',
        backgroundColor: isDark ? '#475569' : '#e2e8f0',
        color: isDark ? '#e2e8f0' : '#475569',
        fontWeight: isDark ? 500 : 500,
        '& .MuiChip-label': {
          px: 1,
        },
        ...sx,
      }}
    />
  );
};

WordCountPill.propTypes = {
  wordCount: PropTypes.number,
  sx: PropTypes.shape({}),
};

WordCountPill.defaultProps = {
  wordCount: undefined,
  sx: {},
};

export default WordCountPill;
